import React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

var LandingPageImageAndList = function LandingPageImageAndList(props) {
  return /*#__PURE__*/_jsx("div", {
    className: "bg-gray-50",
    children: /*#__PURE__*/_jsx("div", {
      className: "px-4 md:px-0 py-12 md:py-20 mx-auto max-w-full md:max-w-3/5",
      children: /*#__PURE__*/_jsxs("div", {
        className: "flex flex-column md:flex-row",
        children: [/*#__PURE__*/_jsxs("div", {
          className: "flex flex-column pr-16 md:w-9/12 mb-12 md:mb-0",
          children: [/*#__PURE__*/_jsx("div", {
            className: "font-serif text-2xl md:text-2rem leading-snug md:leading-snug text-gray-900",
            children: props.title
          }), /*#__PURE__*/_jsx("img", {
            className: "mt-8 w-half hidden md:block md:w-full mb-8 md:mb-0",
            style: {
              maxWidth: '212px'
            },
            src: props.imageHref
          })]
        }), /*#__PURE__*/_jsx("div", {
          className: "flex flex-column",
          children: props.listItems.map(function (item) {
            return /*#__PURE__*/_jsx("div", {
              className: "mb-8",
              children: item
            }, item['key']);
          })
        }), /*#__PURE__*/_jsx("img", {
          className: "my-8 w-3/5 mx-auto block md:hidden",
          style: {
            maxWidth: '212px'
          },
          src: props.imageHref
        })]
      })
    })
  });
};

export default LandingPageImageAndList;